import { Link } from "react-router-dom";
import ComicCard from "@/components/base/ComicCard";
import { comics, getComicById } from "@/mocks/comics";

const featuredIds = ["shanhaijuan", "ranhun", "xindongxuqu", "wuyemian", "wojiashatiaomiao", "xingchenyuanzheng", "qingmeizhuyu", "dishihao"];
const featured = featuredIds.map((id) => getComicById(id)).filter(Boolean) as typeof comics;
const headline = getComicById("shanhaijuan")!;

export default function FeaturedSection() {
  return (
    <section className="bg-background-100/70 py-12 md:py-16" aria-labelledby="featured-heading">
      <div className="container-x">
        <div className="flex flex-col items-start justify-between gap-4 md:flex-row md:items-end">
          <div>
            <span className="inline-flex items-center gap-1.5 rounded-full bg-primary-100 px-3 py-1 text-xs font-semibold text-primary-700">
              <i className="ri-hotspot-fill"></i> 编辑精选
            </span>
            <h2 id="featured-heading" className="mt-3 font-display text-2xl font-black text-foreground-900 md:text-3xl">
              本周热读推荐
            </h2>
          </div>
          <Link to="/category/all" className="flex items-center gap-1 text-sm font-semibold text-primary-600 hover:text-primary-700">
            更多热读 <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        {/* Headline banner */}
        <Link
          to={`/comic/${headline.id}`}
          className="group mt-8 block overflow-hidden rounded-lg border border-background-200/70 bg-background-50"
        >
          <div className="grid grid-cols-1 md:grid-cols-2">
            <div className="relative aspect-[16/9] w-full overflow-hidden bg-background-100 md:aspect-auto md:h-full">
              <img
                src={headline.cover}
                alt={`${headline.title} - 国风奇幻漫画推荐`}
                className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
              />
              <span className="absolute left-3 top-3 rounded-full bg-primary-500 px-3 py-1 text-xs font-semibold text-background-50">
                今日推荐
              </span>
            </div>
            <div className="flex flex-col justify-center p-6 md:p-10">
              <p className="flex items-center gap-2 text-sm font-semibold text-primary-600">
                <i className={headline.categoryId === "qihuan" ? "ri-sparkling-2-fill" : "ri-price-tag-3-fill"}></i>
                {headline.categoryName}漫画 · 评分 {headline.rating}
              </p>
              <h3 className="mt-3 font-display text-2xl font-black text-foreground-900 md:text-3xl">{headline.title}</h3>
              <p className="mt-3 line-clamp-3 text-sm leading-relaxed text-foreground-600 md:text-base">{headline.intro}</p>
              <div className="mt-4 flex flex-wrap gap-2">
                {headline.tags.slice(0, 4).map((t) => (
                  <span key={t} className="rounded-full bg-secondary-100 px-3 py-1 text-xs text-secondary-800">
                    {t}
                  </span>
                ))}
              </div>
              <div className="mt-6 flex items-center gap-4">
                <span className="flex items-center gap-1.5 text-xs text-foreground-600 md:text-sm">
                  <i className="ri-eye-line"></i> {headline.views} 人气
                </span>
                <span className="flex items-center gap-1.5 text-xs text-foreground-600 md:text-sm">
                  <i className="ri-refresh-line"></i> {headline.updateTime} 更新
                </span>
                <span className="ml-auto flex items-center gap-1 whitespace-nowrap rounded-md bg-primary-500 px-4 py-2 text-sm font-semibold text-background-50 transition-colors group-hover:bg-primary-600">
                  立即阅读 <i className="ri-arrow-right-line"></i>
                </span>
              </div>
            </div>
          </div>
        </Link>

        {/* Featured grid */}
        <div className="mt-8 grid grid-cols-2 gap-4 sm:grid-cols-3 lg:grid-cols-4">
          {featured.slice(1).map((comic) => (
            <ComicCard key={comic.id} comic={comic} />
          ))}
        </div>
      </div>
    </section>
  );
}